import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { RpcClientContext } from "../../contexts/rpc";

export const dropoffLocationsQueryKey = (
  draftReturnId?: string,
  returnId?: string,
) => ["dropoffLocations", draftReturnId, returnId] as const;

export const useDropoffLocations = ({
  draftReturnId,
  returnId,
}: {
  draftReturnId?: string;
  returnId?: string;
}) => {
  const client = useContext(RpcClientContext);

  return useQuery({
    queryKey: dropoffLocationsQueryKey(draftReturnId, returnId),
    queryFn: async () => {
      if (!client) {
        throw new Error("RPC client is missing");
      }
      const { locations } = await client.getDropoffLocations({
        draftReturnId,
        returnId,
      });
      return locations;
    },
    enabled: !!client && (!!draftReturnId || !!returnId),
    staleTime: Infinity,
  });
};
